import { activateInlineScripts } from '@otto-ec/global-resources/dom';
import { getGlobalEventMergeIdIfVariationChanged } from '../../_common/client/tracking';
import { BaseComponent } from '../../base-component';
import { renderPdpRecommendations } from '@otto-ec/nexus-registry/reco/cinemas';

export class RecoComplementaryComponent extends BaseComponent {
    public rootSelector = '.js_pdp_reco-complementary';
    private isInitialPageLoad = true;

    public async onHtmlLoaded(): Promise<void> {
        await this.loadReco();
    }

    private async loadReco() {
        if (!this.isPresent()) {
            return;
        }
        const variationId = this.getRootElement().dataset.variationId;
        if (!variationId) {
            return;
        }

        const rootElement = this.getRootElement();

        if (!this.isInitialPageLoad) {
            await activateInlineScripts(rootElement);
        }

        const eventMergeId = getGlobalEventMergeIdIfVariationChanged();
        renderPdpRecommendations({
            variationId,
            eventMergeId,
            target: 'complementary',
        });

        this.isInitialPageLoad = false;
    }
}
